import styled from 'styled-components';
import { transparent, white, formGrey, lighterGrey, medGrey, primary, primaryHover, secondary, quaternary, fontWeightNormal, fontWeightHeavy, fontSizeSmaller, fontSizeSmall, quinary} from '../../styles/styled/colors';

const bgColor = (props) => {
    if (props.hasIcons && !props.fieldActive) return quaternary;
    else if (props.hasIcons && props.fieldActive) return white;
    else if (props.fieldActive) return white;
    else return transparent;
}

const titleColor = (props) => {
    if (props.hasIcons && !props.fieldActive) return white;
    else return medGrey;
}


export const Wrapper = styled.div `
    background: ${bgColor};
    border: 1px solid ${props => props.fieldActive ? formGrey : transparent};
    border-bottom: 0;
    font-weight: ${fontWeightNormal};
    position:relative;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
    supported by Chrome and Opera */

    &:hover {
            cursor: pointer;
    }
    &:focus {
        outline: none;
    }
`
export const Title = styled.p `
    padding-top: 5px;
    font-weight: ${fontWeightHeavy};
    font-size: ${fontSizeSmaller};
    color: ${titleColor};
    text-indent: 0.5rem;
    margin-bottom: 0rem;
    text-transform: uppercase;
    -moz-user-select: none; /* Firefox */
    user-select: none; /* Non-prefixed version, currently
                            supported by Chrome and Opera */
`;
export const Select = styled.div `
    background : ${bgColor};
    color: ${quinary};
    text-transform: uppercase;
    border-bottom: 1px solid ${secondary};
    position: relative;
    font-size: ${fontSizeSmall};
    height: 22px;
    width:100%;
    text-indent: 0.5rem;
    outline: none;
    /*for firefox*/
    -moz-appearance: none;
     /*for chrome*/
    -webkit-appearance:none;
    &:hover {
        cursor: pointer;
    }
    ::placeholder {
        color: ${medGrey};
    }
    -moz-user-select: none; /* Firefox */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
`;
export const OptionWrapper = styled.div `
    position: absolute;
    display:block;
    width: 100%;
    z-index: 99;
    background: ${white};
    border: 1px solid ${props => props.menuActive ? formGrey : transparent};
`

export const Option = styled.div `
    margin-top: 0;
    padding: 0.5rem;
    font-size: 0.8rem;
    color: ${quinary};
    text-transform: uppercase;
    background: ${props => !props.active ? white : lighterGrey };
    &:hover {
        background: ${lighterGrey};
        cursor: pointer;
    }

    -moz-user-select: none; /* Firefox */
         user-select: none; /* Non-prefixed version, currently
                        supported by Chrome and Opera */
`;

export const OptionTag = styled.div `
    border-radius: 5px;
    margin: 0.4rem;
    padding: 0.5rem;
    font-size: ${fontSizeSmall};
    color: ${white};
    text-transform: uppercase;
    background: ${props => !props.active ? primary : primaryHover };
    &:hover {
        background: ${primaryHover};
        cursor: pointer;
    }

    -moz-user-select: none; /* Firefox */
         user-select: none; /* Non-prefixed version, currently
                        supported by Chrome and Opera */
`;

export const Icon = styled.img `
    float: right;
    padding-right: 5px;
`;




// WEBPACK FOOTER //
// ./src/components/Dropdown/Styled.js